/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import Popup from '../../Popup';
import { copyTextToClipboard } from '../../../utils/misc';
import styles from './ReferralCodePopup.scss';

class ReferralCodePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    copyTextToClipboard(copyText, ev) {
        const _this = this;
        copyTextToClipboard(copyText, ev)
            .then(() => {
                _this.setState({
                    displayCopied: true,
                });
                setTimeout(
                    () => _this.setState({ displayCopied: false }),
                    3000,
                );
            }, () => {
                _this.setState({
                    displayCopied: false,
                });
            });
    }

    render() {
        const { title, subtitle, text, url, promoCreditBalance, showPromoBalance, dangerouslySetInnerHTML } = this.props;
        return (
            <Popup
                className="popup-sm"
                popUpClassName={`${styles.referralCodePopUp}`}
                onCloseClick={this.props.onCloseClick}
                config={{
                    fullScreen: false,
                    noPadding: true,
                    scrollable: false,
                    style: {
                        height: 'auto',
                        // width: '600px'
                    },
                }}
            >
                <div className="popup-section p24 pt0">
                    <h5 className="fs28">{title}<br />

                        {dangerouslySetInnerHTML === true && (
                            <div
                                className="text-gray mt16 fs24"
                                onClick={this.props.subtitleClick}
                                dangerouslySetInnerHTML={{ __html: subtitle }}
                            />
                        )}

                        {dangerouslySetInnerHTML !== true && (
                            <div className="text-gray mt16 fs24" onClick={this.props.subtitleClick}>
                                {`${subtitle}`}
                            </div>
                        )}

                    </h5>
                </div>
                <div className="popup-section popup-section-gray p24">
                    <div className={`link-area`}>
                        <form>
                            {text && <div className={`link-title`}>{text}</div>}
                            <div className={`form-group`}>
                                <div className="input-wrapper">
                                    <input
                                        type="text"
                                        id="url"
                                        className="form-control"
                                        value={url}
                                        ref={this.setInputRef}
                                        readOnly={false}
                                        contentEditable={true}
                                        onChange={() => {
                                            // do nothing
                                        }}
                                    />
                                </div>
                            </div>
                        </form>
                        <button
                            type="button"
                            className={`btn btn-large btn-primary btn-block text-uppercase`}
                            onClick={() => {
                                if (!this.state.displayCopied) {
                                    this.copyTextToClipboard(url);
                                }
                            }}
                        >
                            {this.state.displayCopied ? 'Link Copied...' : 'Copy Invite Link'}
                        </button>
                    </div>
                </div>
                {(showPromoBalance && promoCreditBalance) &&
                    (
                        <div className="popup-section p24 pt0">
                            <div className="mt24">
                                <div className="row">
                                    <div className="col-12">
                                        Current Credit Balance: {promoCreditBalance.currency.symbol}{promoCreditBalance.balance}
                                        {promoCreditBalance.balance > 0 &&
                                            <p>*{promoCreditBalance.currency.symbol}{promoCreditBalance.balance} credit will be automatically applied to your next subscription payment.</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
            </Popup>
        );
    }
}

export default ReferralCodePopup;
